import type { PrimaryContact } from '@recruitee/billing-information-types';
import { createSingleEntityStore } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<PrimaryContact>()(
  'PrimaryContactEntity',
  {
    customActions: adapter => ({
      update: (state, payload: { data: Partial<PrimaryContact>; isCreate: boolean }) =>
        adapter.markAsPending(state),
    }),
  },
);

export {
  actions as PrimaryContactEntityActions,
  selectors as PrimaryContactEntitySelectors,
  reducer as PrimaryContactEntityReducer,
  namespace as PrimaryContactEntityNamespace,
};
